module.exports = __webpack_public_path__ + "static/media/star.12770ae0.svg";